var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestoneHero2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 397,
    viewBox: "0 0 290 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.387 280.223C189.438 299.278 129.722 274.228 113.006 224.272C96.2901 174.316 128.905 118.371 185.854 99.3156C242.802 80.2601 302.519 105.31 319.235 155.266C335.951 205.222 303.336 261.167 246.387 280.223Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.435 176.523L266.993 137.522C276.868 134.218 287.551 139.544 290.856 149.419L290.859 149.43C294.164 159.305 288.837 169.988 278.962 173.293L162.404 212.294C152.529 215.598 141.846 210.272 138.542 200.397L138.538 200.386C135.234 190.511 140.56 179.827 150.435 176.523Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.329 139.199C108.36 118.372 119.594 95.8392 140.421 88.8703C161.248 81.9014 183.781 93.1356 190.75 113.963L193.028 120.77C199.997 141.597 188.762 164.13 167.935 171.099C147.108 178.068 124.575 166.833 117.606 146.006L115.329 139.199Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.911 153.236C148.531 156.375 137.313 148.115 132.853 134.788C128.394 121.461 132.383 108.113 141.762 104.975C151.142 101.836 162.361 110.096 166.82 123.423C171.279 136.75 167.291 150.098 157.911 153.236Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.067 95.7804L144.974 117.03L165.913 105.975L145.067 95.7804Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.741 113.967C183.772 93.1399 195.006 70.6068 215.833 63.6379C236.66 56.669 259.193 67.9032 266.162 88.7303L268.44 95.5373C275.409 116.364 264.175 138.897 243.348 145.866C222.52 152.835 199.987 141.601 193.018 120.774L190.741 113.967Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.335 127.999C223.955 131.138 212.736 122.878 208.277 109.551C203.817 96.224 207.806 82.876 217.186 79.7375C226.566 76.599 237.784 84.8584 242.244 98.1855C246.703 111.513 242.714 124.861 233.335 127.999Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.492 70.5432L220.399 91.7931L241.326 80.7413L220.492 70.5432Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.605 154.538L155.314 194.789",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M129.326 212.1L99.7574 241.737L83.4491 192.999C95.1241 186.645 99.5119 172.952 94.6769 162.914C90.9947 155.265 82.3108 150.463 72.8345 150.871C70.993 144.99 59.4777 109.143 46.5496 108.171C45.8497 108.115 44.586 108.033 43.3271 108.757C35.3197 113.366 44.0491 141.227 45.6513 146.203C38.1246 157.565 30.5979 168.927 23.0712 180.289C24.2856 183.616 26.7205 188.933 31.565 194.099C37.792 200.719 44.726 203.572 48.291 204.763C55.7052 230.502 63.1448 252.02 69.3265 268.571C76.252 287.119 79.0996 292.802 84.7354 295.168C105.057 303.683 139.841 259.963 145.054 253.299",
    fill: "#5B5BD8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M129.326 212.1L99.7574 241.737L83.4491 192.999C95.1241 186.645 99.5119 172.952 94.6769 162.914C90.9947 155.265 82.3108 150.463 72.8345 150.871C70.993 144.99 59.4777 109.143 46.5496 108.171C45.8497 108.115 44.586 108.033 43.3271 108.757C35.3197 113.366 44.0491 141.227 45.6513 146.203C38.1246 157.565 30.5979 168.927 23.0712 180.289C24.2856 183.616 26.7204 188.933 31.565 194.099C37.792 200.719 44.726 203.572 48.291 204.763C55.7052 230.502 63.1448 252.02 69.3265 268.571C76.252 287.119 79.0996 292.802 84.7354 295.168C105.057 303.683 139.841 259.963 145.054 253.299",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5471 170.141C70.5153 175.377 63.4077 176.115 59.7459 173.051C56.5915 170.41 56.8963 165.704 56.941 165.083C57.4445 158.784 63.7633 153.049 72.8327 150.859",
    fill: "#5B5BD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5471 170.141C70.5153 175.377 63.4077 176.115 59.7459 173.051C56.5915 170.41 56.8963 165.704 56.941 165.083C57.4445 158.784 63.7633 153.049 72.8327 150.859",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4534 180.896C44.4659 182.565 37.6457 175.618 34.2199 165.38C30.7942 155.142 32.0602 145.489 37.0476 143.821C42.0351 142.152 48.8554 149.098 52.2812 159.337C55.7069 169.575 54.4409 179.227 49.4534 180.896Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3841 186.943C26.3966 188.612 20.0981 183.224 17.316 174.91C14.5339 166.595 16.3217 158.502 21.3091 156.833C26.2966 155.164 32.5951 160.552 35.3772 168.866C38.1593 177.181 36.3716 185.274 31.3841 186.943Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.21 210.212C315.446 209.353 343.245 209.564 370.238 226.405C378.673 231.669 385.372 237.514 390.587 242.96C384.407 260.343 388.247 274.309 394.549 276.591C399.787 278.484 408.122 272.819 414.589 263.944C432.542 263.121 446.514 257.146 449.114 247.913C449.89 245.143 451.381 235.914 428.755 216.778C410.882 201.666 373.995 177.009 302.695 164.232",
    fill: "#5B5BD8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302.21 210.212C315.446 209.353 343.245 209.564 370.238 226.405C378.673 231.669 385.372 237.514 390.587 242.96C384.407 260.343 388.247 274.309 394.549 276.591C399.787 278.484 408.122 272.819 414.589 263.944C432.542 263.121 446.514 257.146 449.114 247.913C449.89 245.143 451.381 235.914 428.755 216.778C410.882 201.666 373.995 177.009 302.695 164.232",
    stroke: "#1E1E1E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneHero2);
export default __webpack_public_path__ + "static/media/milestone-hero2.fec37b29dc6b38a17f32b3e5f5d47224.svg";
export { ForwardRef as ReactComponent };